<div class="panel-header">
  <div class="row no-gutters mb-2">
    <div class="col align-self-center title-col">
      <h2 class="panel-title" [ngClass]="{ dot: dottedTitle }">
        {{ (translatedHeader | titlecase) || ('global.' + header | transloco | titlecase) }}
        @if (tooltipText) {
          <span
            class="info-icon ml-2 dashboard-tooltip"
            matTooltipClass="dig-tooltip"
            #tooltip="matTooltip"
            (click)="tooltip.toggle()"
            matTooltip="{{ tooltipText | transloco }}"
          >
            <span inlineSVG="/icons/icon-info-circle-v2.svg"></span>
          </span>
        }
      </h2>
    </div>
    @if (toggleOpen) {
      <div class="col-auto align-self-center col-arrow" (click)="collapse()">
        @if (required) {
          <span class="required">{{ 'global.required' | transloco }}</span>
        }
        <span class="icon icon-arrow" [inlineSVG]="'/icons/icon-arrow-' + (open ? 'up' : 'down') + '.svg'"></span>
      </div>
    }
  </div>
</div>
